import { AlertDialog } from "@preownedfront/lib-reowds";
import { t } from "i18next";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import useAddressListQuery from "src/hooks/React_Query/Address/useAddressListQuery";
import useMyPersonalDataQuery from "src/hooks/React_Query/Customer/Buyer/PersonalData/useMyPersonalDataQuery";
import useSellerMyProductList from "src/hooks/React_Query/Customer/Seller/Products/MyItems/useSellerMyProductList";
import { useAppState } from "src/hooks/state/use-app-state";
import { ROUTE_PATHS } from "src/utils/constants";
import {
  hasInvalidateAddress,
  hasProducts,
  routeValidations,
} from "./InvalidReturnAddressAlert.utils";

export function InvalidReturnAddressAlert() {
  const { pathname } = useLocation();
  const isProfileSection = pathname.includes(ROUTE_PATHS.PROFILE);
  const history = useHistory()
  
  const user = useAppState((state) => state.profile.user);
  const { data: customerData} = useMyPersonalDataQuery(!!user?.logonId && routeValidations());
  const { data: addressList } = useAddressListQuery(!!customerData && routeValidations());
  const { data: myProductsListResponse } = useSellerMyProductList(!!addressList &&
    hasInvalidateAddress(customerData?.data?.returnAddress, addressList?.data?.addresses));

  if (!!customerData && hasInvalidateAddress(customerData?.data?.returnAddress, addressList?.data?.addresses) && hasProducts(myProductsListResponse)) {
    return (
      <AlertDialog
        open={!isProfileSection}
        title={t("return-addresses-invalid-global-alert-title")}
        description={t("return-addresses-invalid-globa-alert-description")}
        acceptButtonLabel={t("return-addresses-invalid-globa-alert-button")}
        onClickAcceptButton={() => {history.push(`${ROUTE_PATHS.PROFILE}${ROUTE_PATHS.MY_ADDRESSES}${ROUTE_PATHS.SENDER_ADDRESS}`)}}
      />
    );
  }

  return null;
}
